import { jsxs as c, jsx as r } from "@emotion/react/jsx-runtime";
import { CheckButtonContainer as m, InvisibleInput as s } from "./CheckButton.styled.js";
import { Icon as p } from "../../Icon/index.js";
import { Text as C } from "../../Text/index.js";
const g = ({
  text: a,
  icon: t,
  onChange: n,
  checked: o = !1,
  disabled: e = !1,
  textVariant: i = "bodySSemibold"
}) => /* @__PURE__ */ c(m, { gap: "4px", alignItems: "center", children: [
  /* @__PURE__ */ r(s, { "aria-disabled": e, "aria-checked": o, type: "checkbox", checked: o, onChange: (l) => {
    !e && n && n(l);
  } }),
  t !== void 0 && /* @__PURE__ */ r(p, { color: o ? "primary" : "secondary", icon: t }),
  /* @__PURE__ */ r(C, { variant: i, color: o ? "primary" : "default", children: a })
] });
export {
  g as CheckButton
};
